import get from 'lodash/get';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import EditNoteButton from '../sessions/EditNoteButton';
import { formatAppointmentTime } from '../../helpers/appointments';
import { formatSessionLocation } from '../../helpers/sessions';
import { formatPatientName, formatPatientPhone } from '../../helpers/patients';
import SessionStatus from '../sessions/SessionStatus';
import { ClockIcon, BlackPersonIcon, PhoneIcon, PinIcon, GreyLaunchIcon } from '../../styles/icons';
import { MAX_WITH_MOBILE_MEDIA } from '../../config/getTheme';
import './AppointmentListItem.scss';

const AppointmentListItem = props => {
  const navigate = useNavigate();
  const { appointment, isMobile } = props;
  const patientId = get(appointment, 'patient.id');
  const sessionId = get(appointment, 'session.id');

  return (
    <Box key={appointment.id} className='AppointmentListItem mx-table__row'>
      <Box className='mx-table__cell' paddingLeft={{ xs: '7px', sm: '15px' }}>
        <Stack direction={{ xs: 'row', sm: 'column' }} alignItems='flex-start' justifyContent={{ xs: 'space-between', sm: 'flex-start' }}>
          <Stack direction='row' alignItems='center' className='Appointment__time'>
            <ClockIcon />
            <Typography variant={isMobile ? 'large600Tight' : 'subtitle2'} noWrap>
              {formatAppointmentTime(appointment)}
            </Typography>
          </Stack>

          {!isMobile
            ?
            <Stack direction='row' alignItems='center' className='Appointment__name'>
              <BlackPersonIcon />
              <Typography variant={isMobile ? 'large600TightInter' : 'subtitle2Inter'} color='text.primary' noWrap>
                {formatPatientName(get(appointment, 'patient'))}
              </Typography>
            </Stack>
            :
            <Stack direction='row' alignItems='center'>
              <SessionStatus
                session={get(appointment, 'session')}
                onlyIcon
                fontSize='1.4rem'
              />
              <Button
                sx={{
                  minWidth: 'auto',
                  marginLeft: '15px',
                  padding: '3px 2px 0px 2px',
                }}
                onClick={() => navigate(`/providers/sessions/view/${sessionId}`)}
              >
                <GreyLaunchIcon />
              </Button>
            </Stack>
          }
        </Stack>
      </Box>
      <Box className='mx-table__cell' style={{ display: !isMobile ? 'none' : '' }}>
        <Stack direction='row' alignItems='center' className='Appointment__name'>
          <BlackPersonIcon />
          <Typography variant={isMobile ? 'large600TightInter' : 'subtitle2Inter'} color='text.primary'>
            {formatPatientName(get(appointment, 'patient'))}
          </Typography>
        </Stack>
      </Box>
      <Box className='mx-table__cell'>
        {formatPatientPhone(get(appointment, 'patient')) &&
          <Stack direction='row' alignItems='center' className='Appointment__phone'>
            <PhoneIcon />
            <Typography
              variant='largeInter'
              color='text.light'
              sx={{
                lineHeight: '1rem',
                letterSpacing: '-0.03125rem',
                [MAX_WITH_MOBILE_MEDIA]: {
                  fontSize: '0.6875rem',
                },
              }}
            >
              {formatPatientPhone(get(appointment, 'patient'))}
            </Typography>
          </Stack>
        }
      </Box>
      <Box className='mx-table__cell'>
        {formatSessionLocation(get(appointment, 'session') || appointment) &&
          <Stack direction='row' alignItems='center' className='Appointment__location'>
            <PinIcon />
            <Typography
              variant='largeInter'
              color='text.light'
              sx={{
                lineHeight: '1rem',
                letterSpacing: '-0.03125rem',
                [MAX_WITH_MOBILE_MEDIA]: {
                  fontSize: '0.6875rem',
                },
              }}
            >
              {formatSessionLocation(get(appointment, 'session') || appointment, {returnLink: true})}
            </Typography>
          </Stack>
        }
      </Box>
      <Box className='mx-table__cell' sx={{ paddingRight: !isMobile ? '16px' : ''}}>
        <Stack direction='row' alignItems='center' justifyContent={{ xs: 'space-between', sm: 'flex-end' }} className='Appointment__button-group'>
          <EditNoteButton
            disabled={appointment?.session?.is_canceled}
            variant='outlined'
            size='large'
            stopPropagation={true}
            session={appointment?.session}
            textOnly
          />
          <Button
            disabled={appointment?.session?.is_canceled}
            variant='outlined'
            size='large'
            onClick={e => {
              e.stopPropagation();
              navigate(`/providers/patients/messages/${patientId}`);
            }}
          >
            Message
          </Button>
        </Stack>
      </Box>
      <Box
        className='mx-table__cell'
        sx={{
          display: isMobile ? 'none' : '',
          textAlign: 'right',
          width: '20px',
          paddingLeft: 0,
          paddingRight: '15px'
        }}
      >
        <Stack
          direction='column'
          alignItems='flex-end'
          justifyContent='center'
          spacing={1}
          style={{
            position: 'relative',
            top: '-6px',
          }}
        >
          <Button
            onClick={() => navigate(`/providers/sessions/view/${sessionId}`)}
            sx={{ minWidth: 'auto', paddingRight: 0}}
          >
            <GreyLaunchIcon style={{width: '0.9375rem', height: '0.9375rem'}}/>
          </Button>
          <SessionStatus
            session={get(appointment, 'session')}
            onlyIcon
            fontSize='1.4rem'
          />
        </Stack>
      </Box>

      {/* <CustomCard
        listItems={[
          {
            Icon: ClockIcon,
            text: formatAppointmentTime(appointment),
          },
          {
            Icon: PersonIcon,
            text: formatPatientName(get(appointment, 'patient')),
          },
          {
            Icon: PhoneIcon,
            text: formatPatientPhone(get(appointment, 'patient')),
          },
          {
            Icon: PinIcon,
            text: formatSessionLocation(
              get(appointment, 'session')
              || appointment
            ),
          },
        ]}
        buttons={[
          <Button 
            fullWidth
            onClick={e => {
              e.stopPropagation();
              navigate(`/providers/patients/messages/${patientId}`);
            }}
          >
            Send Message
          </Button>,
          <EditNoteButton 
            fullWidth
            variant='text'
            stopPropagation={true}
            session={appointment?.session} 
          />
        ]}
        passButtonChildren={true}
        onClick={() => navigate(`/providers/sessions/view/${sessionId}`)}
      /> */}
    </Box >
  );
};

export default AppointmentListItem;
